
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/products/[sku]",
      function () {
        return require("private-next-pages/d/account/products/[sku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/products/[sku]"])
      });
    }
  